import CoverDefaultSrc from '@/assets/cover-default.png';
import { Dialog } from '@/components/Dialog';
import { PublishedIcon } from '@/components/Icons';
import { Button } from '@/pages/Home/components/SongDetail';
import { PropertiesItem } from '@/pages/Home/components/SongDetail/Properties';
import { publishAudio, unPublishAudio, updateDetail } from '@/service/audioList';
import { displayDuration } from '@/utils';
import dayjs from 'dayjs';
import React, { useRef } from 'react';
import { useRefreshData } from './useRefreshData';

export const usePublishDialog = ({ id }: { id: string }) => {
  const { refreshAudioInList, refreshSongDetail, refreshCatalogOverview } = useRefreshData();
  const onShowPublishDialog = (
    {
      name,
      duration,
      createAt,
    }: {
      name?: string;
      duration?: number;
      createAt?: string;
    },
    title?: string,
  ) => {
    Dialog.info({
      closeClassName: 'hidden',

      title: title || 'Publish Track',
      contentJSX: ({ onClose }) => {
        const textareaRef = useRef<HTMLTextAreaElement | null>(null);
        return (
          <div className=" p-jen-spacing-16 text-jen-content-secondary">
            <div className=" text-jen-size-heading-05">
              By publishing your track to the discover playlist, it will be displayed publicly for people to find.
            </div>
            <div className="flex mt-[32px] gap-jen-spacing-16 text-[12px]">
              <img src={CoverDefaultSrc} className="w-[160px] h-[160px] rounded-lg " />
              <div className="flex-1">
                <div>TRACK NAME</div>
                <textarea
                  ref={textareaRef}
                  tabIndex={-1}
                  rows={3}
                  className="h-[72px] box-border  text-jen-content-primary text-[16px] p-jen-spacing-8 w-full resize-none rounded-jen-spacing-8 border border-jen-border"
                  defaultValue={name}
                />
                <PropertiesItem label="DURATION" value={displayDuration(duration)} />
                <PropertiesItem label="FORMAT" value={''} />
                <PropertiesItem label="CREATED ON" value={dayjs(createAt).format('h:mm a DD MMM YY')} />
              </div>
            </div>
            <Button
              onClick={async () => {
                const name = textareaRef?.current?.value?.trim();
                if (name) {
                  await updateDetail({
                    id,
                    name,
                  });
                  await publishAudio({
                    id,
                  });
                  refreshAudioInList({ id });
                  refreshSongDetail();
                  refreshCatalogOverview();
                  onClose();
                }
              }}
              icon={<PublishedIcon fillColor="#fff" />}
              className="text-jen-content-primary-contrast bg-jen-interactive-primary mt-jen-spacing-32 h-[40px]"
              text="Publish"
            />
            <Button
              onClick={onClose}
              className=" bg-jen-interactive-accent text-jen-interactive-primary mt-jen-spacing-8 h-[40px]"
              text="Cancel"
            />
          </div>
        );
      },
    });
  };
  const onShowPrivateDialog = () => {
    Dialog.info({
      closeClassName: 'left-auto right-4 !p-0 rounded-[4px] ',
      dialogContentClassName: 'bg-jen-content-primary-contrast ',
      title: 'Unpublish Track',
      contentJSX: ({ onClose }) => {
        return (
          <div className=" p-jen-spacing-16 text-jen-content-secondary">
            <div className=" text-jen-size-heading-05">
              It will no longer show on the JEN Discover page. Shared links will still be accessible.
            </div>
            <Button
              onClick={async () => {
                await unPublishAudio({
                  id,
                });
                refreshSongDetail();
                refreshCatalogOverview();
                refreshAudioInList({ id });

                onClose();
              }}
              className="text-jen-content-primary-contrast bg-jen-interactive-primary mt-jen-spacing-32 h-[40px]"
              text="Make Track Private"
            />
            <Button
              onClick={onClose}
              className=" bg-jen-interactive-accent text-jen-interactive-primary mt-jen-spacing-8 h-[40px]"
              text="Cancel"
            />
          </div>
        );
      },
    });
  };
  return { onShowPrivateDialog, onShowPublishDialog };
};
